import React, { useState } from 'react'
import { Outlet , Navigate } from 'react-router-dom'
import {useAuth} from "../../../usercontext";
import { AdminHeader } from "../header";
import AdminSidebar from "../sidebar";
import Footer from "../../footer";

export default function AdminLayout() {
 const [mobileMenu, setMobileMenu] = useState(false)
  const { profile } = useAuth();
  //console.log("Layout",profile);

  if(!profile || profile.role !== "Admin")
  return <Navigate to={"/login"} />

  return (
    <div className='main-wrapper'>
      <AdminHeader
        activeMenu={'Dashboard'}
        setMobileMenu={setMobileMenu}
        mobileMenu={mobileMenu}
      />
      <div className='page-content instructor-page-content'>
        <div className='container'>
          <div className='row'>
            {/* Sidebar */}
            <AdminSidebar
              activeMenu={'Dashboard'}
              setMobileMenu={setMobileMenu}
              mobileMenu={mobileMenu}
            />
            <Outlet />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}
